import { combineReducers } from 'redux';
import runtime from './runtime';
import searchPreferences from './searchPreferences';
import location from './location';
import newBooking, { newBookingInitialState } from './newBooking';
import pastBookings from './pastBookings';
import position from './position';
import imageData from './imageData';
import insurers from './insurers';
import npi from './npi';
import eligibilityCheck from './eligibilityCheck';
import autocomplete from './autocomplete';
import waitList from './waitList';
import outsideServiceArea from './outsideServiceArea';
import toolTip from './toolTip';
import reviews from './reviews';
import tracking from './tracking';
import requestSolvEmail from './requestSolvEmail';
import favorite from './favorite';
import login from './login';
import account from './account';
import insuranceProfile from './insuranceProfile';
import distanceMatrix from './distanceMatrix';
import clinicLead from './clinicLead';
import waitTime from './waitTime';
import content from './content';
import payment from './payment';
import addReview from './addReview';
import paperwork from '../ducks/paperwork';
import invoices from './invoices';
import charges from './charge';
import groupLocations from './groupLocations';
import popularCities from './popularCities';
import popularCitiesNearby from './popularCitiesNearby';
import paymentCustomer from '../ducks/payments/customers';
import userProfilePhoto from '../ducks/profile/photo';
import addInsurance from './addInsurance';
import insuranceDetails from '../ducks/insurance/details';
import clinicReviewCalculator from './clinicReviewCalculator';
import nearbyLocations from '../ducks/nearbyClinics';
import bookingNotes from '../ducks/booking/notes';
import bookingImages from '../ducks/booking/images';
import careers from '../ducks/careers';
import locations from '../ducks/locations';
import leaveAReview from '../ducks/leaveAReview';
import solvRatings from '../ducks/solvRatings';
import reminders from '../ducks/reminders';
import searchResults from '../ducks/searchResults';
import providerBooking from '../ducks/bigTexBooking';
import sessionTrackingProperties from '../ducks/tracking';
import webPushSubscriptions from '../ducks/webPushSubscriptions';
import maryMagicSurvey from '../ducks/maryMagicSurvey';
import marketplaceInsurers from '../ducks/marketplaceInsurers';
import onboarding from '../ducks/onboarding';
import specialties from '../ducks/specialties';
import userProfilePhotos from '../ducks/userProfilePhotos';
import universalSearch from '../ducks/universalSearch';
import abTests from '../ducks/abTests';
import verifyProfile from '../ducks/verifyProfile';
import videoVisit from '../ducks/videoVisit';
import storageSession from 'redux-persist/lib/storage/session';
import { persistReducer } from 'redux-persist';
import mergeWith from 'lodash/mergeWith';
import isEqual from 'lodash/isEqual';

import { safeGet } from '../core/util/object';

const deepMergeReconcileNewBooking = (inboundState, originalState, reducedState) =>
  mergeWith(inboundState, reducedState, (inboundStateValue, reducedStateValue, key) =>
    isEqual(reducedStateValue, safeGet(newBookingInitialState)(key))
      ? inboundStateValue
      : reducedStateValue
  );

const newBookingPersistConfig = {
  key: 'newBooking',
  storage: storageSession,
  stateReconciler: deepMergeReconcileNewBooking,
};

export default combineReducers({
  runtime,
  paperwork,
  searchResults,
  searchPreferences,
  location,
  locations,
  newBooking: persistReducer(newBookingPersistConfig, newBooking),
  nearbyLocations,
  pastBookings,
  position,
  insurers,
  npi,
  addReview,
  eligibilityCheck,
  autocomplete,
  waitTime,
  userProfilePhotos,
  imageData,
  waitList,
  outsideServiceArea,
  toolTip,
  reviews,
  tracking,
  requestSolvEmail,
  favorite,
  account,
  login,
  payment,
  insuranceProfile,
  distanceMatrix,
  clinicLead,
  content,
  clinicReviewCalculator,
  invoice: invoices,
  charges,
  groupLocations,
  popularCities,
  popularCitiesNearby,
  paymentCustomer,
  userProfilePhoto,
  addInsurance,
  insuranceDetails,
  bookingNotes,
  bookingImages,
  leaveAReview,
  careers,
  solvRatings,
  reminders,
  universalSearch,
  sessionTrackingProperties,
  webPushSubscriptions,
  providerBooking,
  maryMagicSurvey,
  marketplaceInsurers,
  onboarding,
  specialties,
  abTests,
  verifyProfile,
  videoVisit,
});
